import * as Sentry from "@sentry/react";

const isDev = import.meta.env.DEV;

/** Normalise une erreur API / objet en `Error` pour Sentry. */
export function toLogError(value) {
  if (value instanceof Error) return value;
  if (value == null) return new Error("(no detail)");
  const msg = typeof value === "object" && "message" in value && value.message != null
    ? String(value.message)
    : String(value);
  return new Error(msg);
}

export const logger = {
  error: (message, error, context = {}) => {
    if (isDev) {
      console.error(`[AthleOS] ${message}`, error, context);
    }
    if (error instanceof Error) {
      Sentry.captureException(error, { extra: { message, ...context } });
    } else {
      Sentry.captureMessage(String(message), { level: "error", extra: { error, ...context } });
    }
  },

  warn: (message, context = {}) => {
    if (isDev) {
      console.warn(`[AthleOS] ${message}`, context);
    }
  },

  info: (message, context = {}) => {
    if (isDev) {
      console.log(`[AthleOS] ${message}`, context);
    }
  },
};
